// Copyright (c) 2021, 37.78 Tecnologia Ltda. All rights reserved.

import React from "react";

import {
  Alert,
  IconButton,
  Snackbar as GobanSnackbar,
  styled,
} from "@3778.care/goban";
import CloseIcon from "@mui/icons-material/Close";
import PropTypes from "prop-types";

import { useIsDesktop } from "../../../../util/useIsDesktop";

const StyledSnackbar = styled(GobanSnackbar)(({ theme: { breakpoints } }) => ({
  "&.MuiSnackbar-anchorOriginBottomCenter": {
    [breakpoints.only("sm")]: {
      width: "90%",
    },
  },
}));
const StyledAlert = styled(Alert)(() => ({
  alignItems: "center",
}));

export const Snackbar = ({ handleClose, message, open }) => {
  const isDesktop = useIsDesktop();

  const anchor = {
    horizontal: isDesktop ? "left" : "center",
    vertical: "bottom",
  };

  const CloseButton = () => (
    <IconButton
      aria-label="close"
      color="inherit"
      onClick={handleClose}
      size="small"
    >
      <CloseIcon fontSize="small" />
    </IconButton>
  );

  return (
    <StyledSnackbar
      action={<CloseButton />}
      anchorOrigin={anchor}
      autoHideDuration={5000}
      onClose={handleClose}
      open={open}
    >
      <StyledAlert onClose={handleClose} severity="success">
        {message}
      </StyledAlert>
    </StyledSnackbar>
  );
};

Snackbar.propTypes = {
  handleClose: PropTypes.func.isRequired,
  message: PropTypes.string.isRequired,
  open: PropTypes.bool.isRequired,
};
